import { useEffect, useMemo, useRef } from 'react';
import { AdvancedSettingsActions } from "../AdvancedSettingsActions";
import { isSettingActive } from "../ServiceAdvancedSettings.utils";
export function useModalCheckedSettings(_ref) {
  let {
    enabled,
    settings,
    service,
    actionContext
  } = _ref;
  const previousAvailableSettingsRef = useRef(new Set());
  const availableSettings = useMemo(() => {
    return new Set(settings.filter(setting => !setting.disabled).map(setting => setting.type));
  }, [settings]);
  useEffect(() => {
    if (!enabled) return;

    // find settings that were previously available but are now unavailable
    const settingsToDeactivate = new Set([...Array.from(previousAvailableSettingsRef.current).filter(type => !availableSettings.has(type)), ...settings.filter(s => !availableSettings.has(s.type)).map(s => s.type)]);

    // deactivate any settings that are still active on the service
    settingsToDeactivate.forEach(type => {
      if (isSettingActive({
        type,
        service
      })) {
        AdvancedSettingsActions[type].deactivate(actionContext);
      }
    });
    previousAvailableSettingsRef.current = availableSettings;
  }, [enabled, availableSettings, service, actionContext, settings]);
}